import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from "../../../InputComponent"
import { LanguageFactory, LocalPersistence, ApiCallsFactory } from '../../../../factories';
import { useLanguage } from '../../../../store/languageContext'
import SearchDebounceBar from '../../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../../factories/propertySearchs';
import { Button, Card, Table } from 'antd';
import Edit from './Edit';
import PageContainer from '../../../CSIComponents/PageContainer';
import Add from './Add';
import Loading from '../../../Loading';
import { enableContent } from '../../../../helpers/misc/disableContent'
import { sortHelper } from '../../../../helpers/misc/sortHelper'


const LoyailyPrograms = (props: any) => {
    const { language, setLanguage } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState([]);
    const [addFlag, setAddFlag] = useState(false);
    const [editFlag, setEditFlag] = useState(false);
    const [total, setTotal] = useState(dataSource.length)
    const [data, setData] = useState(dataSource);
    const [rowData, setRowData] = useState([]);
    const [addLoading, setAddLoading] = useState(false)
    const columns = [
        {
            title: '',
            key: 'index',
            render: (text: string, record: [], index: number) => index += 1,
            width: '40px'
        },
        {
            title: 'Closure Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a:[], b:[]) => sortHelper(a, b, 'name'),
            showSorterTooltip: false,
        },
        {
            title: 'Start Date',
            dataIndex: 'startdate',
            key: 'startdate',
            sorter: (a:[], b:[]) => sortHelper(a, b, 'startdate'),
            showSorterTooltip: false,
        },
        {
            title: 'End Date',
            dataIndex: 'enddate',
            key: 'enddate',
            sorter: (a:[], b:[]) => sortHelper(a, b, 'enddate'),
            showSorterTooltip: false,
        },
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const getData = async () => {
        const get_session = new LocalPersistence('session')
        const session = await get_session.getSessionPersistence()
        // getting data from the server
        const basicInfo = new ApiCallsFactory(`/property/basicinformation?supplier=${session.supplier}&propertyid=${session.propertyId}`, session.token)
        const resData: any =  await basicInfo.getData()
        resData.property.basicinformation?.closures?.forEach((item: any, index: number) => { item.key = '' + index; })
        setDataSource(resData.property.basicinformation?.closures || []);
        setData(resData.property.basicinformation?.closures)
    }
    useEffect(() => {
        getData()
    }, [])


    useEffect(() => {
       if (!addFlag) enableContent()
    },[addFlag])

    useEffect(() => {
        if(!editFlag) enableContent()
    },[editFlag])

    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                if (typeof item[col.dataIndex] === 'string') {
                    itemData[col['dataIndex']] = item[col.dataIndex].toLowerCase();
                }
            })
            return JSON.stringify(Object.values(itemData))
                .indexOf(query.toLocaleLowerCase()) > -1;

        })

        setDataSource(filterData);
    }
    const cancelAddAndEdit = () => {
        getData()
        setAddFlag(false);
        setEditFlag(false);
    }
    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])
    return (addLoading ? <Loading type="large" /> : <>
        {!addFlag && !editFlag && <PageContainer>
            <Card style={{ marginTop: 0 }}>
                <Grid container spacing={0} className="containerSpacing py-0">
                    <Grid item xs={12} className="p-0">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Closures</div>
                            <div><Button style={{ background: '#004771', color: '#fff', width: 60, height: 28 }}
                            onClick={() => { setAddFlag(true); setEditFlag(false);}}>Add</Button></div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <ImputComponent
                            className = 'SearchBar'
                            label='Search'
                            labelShrink = {true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder='Search Closures'
                            endAdornment={<SearchIcon style={{color: '#9a9a9a'}}/>}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="p-0">
                        <Table
                            columns={columns}
                            dataSource={
                                dataSource
                            }
                            pagination={{
                                size: "small",
                                total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                defaultPageSize: 10,
                                defaultCurrent: 1,
                                onChange: (page, pageSize) => {
                                    console.log(page + '===' + pageSize)
                                }
                            }}
                            onRow={record => {
                                return {
                                    onClick: event => {
                                        setAddFlag(false);
                                        setEditFlag(true);
                                        setRowData(record);
                                    },
                                };
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>
        </PageContainer>}
        {addFlag && <Add cancelAddAndEdit={cancelAddAndEdit} />}
        {editFlag && <Edit isEditable={true} disableTabPanes={true} cancelAddAndEdit={cancelAddAndEdit} rowData={rowData} />}
    </>

    )
}

export default LoyailyPrograms;
